import React, { CSSProperties, ReactNode } from 'react'
import { getImage, IGatsbyImageData } from 'gatsby-plugin-image'
import { classNames } from '@utils/genUtils'
import BackgroundImageLoader from '../backgroundImageLoader';
import { twMerge } from 'tailwind-merge';

interface IProps {
  gatsbyDataImg?: IGatsbyImageData | null
  children?: ReactNode
  containerClasses?: string
  innerDivClasses?: string
  containerStyles?: CSSProperties
  showBlurImage?: boolean
  disableMinHeight?: boolean
  bgImageClasses?: string
  bgSrcClasses?: string
}

const BackgroundImageV5 = ({ gatsbyDataImg = null, children, containerStyles, containerClasses, innerDivClasses, showBlurImage = true, disableMinHeight = false, bgImageClasses, bgSrcClasses }: IProps) => {

  const minHeight = disableMinHeight ? '' : 'min-h-[300px] md:min-h-[500px] lg:min-h-[700px]'

  return (
    <div
      style={containerStyles ? containerStyles : {}}
      className={twMerge('bgContainer overflow-hidden relative', containerClasses ? containerClasses : '')}
    >
      <div className={twMerge(`bgInner relative h-full ${minHeight}`, innerDivClasses ? innerDivClasses : '')}>
        <BackgroundImageLoader
          bgSrcClasses={bgSrcClasses}
          bgImageClasses={bgImageClasses}
          showBlurImage={showBlurImage}
          gatsbyDataImg={gatsbyDataImg} />
        {children}
      </div>
    </div>
  )
}

export default BackgroundImageV5

const variants = {
  initial: {
    opacity: 0,
    transition: { duration: .5, delay: .25 },
  },
  exit: {
    opacity: 0,
    transition: { duration: .5, delay: .25 },
  },
  enter: {
    opacity: 1,
    transition: { duration: .5, delay: .25 },
  },
}